import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'



/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/map',
  //   children: [
  //     {
  //       path: 'map',
  //       component: () => import('@/map/map'),
  //       name: '地图',
  //       meta: { title: '地图', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  {
    path: '/',
    component: () => import('@/map/map'),
  },
  {
      path: '/mapleakrate',
      component: () => import('@/map/map'),
    
    
  },
  {
    path: '/mapuse',
    component: () => import('@/map/mapUse'),
  },
  {
    path: '/mapsave',
    component: () => import('@/map/mapSave'),
  },
  {
    path: '/mappipedensity',
    component: () => import('@/map/mapPipeDensity'),
  },
  {
    path: '/mappipelength',
    component: () => import('@/map/mapPipeLength'),
  },
  {
    path: '/mapwaterrate',
    component: () => import('@/map/mapWaterRate'),
  },
  {
    path: '/mapwatertotal',
    component: () => import('@/map/mapWaterTotal'),
  },
  {
    path: '*',
    component: () => import('@/map/map'),
  },

  // {
  //   path: '/documentation',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/documentation/index'),
  //       name: 'Documentation',
  //       meta: { title: 'Documentation', icon: 'documentation', affix: true }
  //     }
  //   ]
  // },
  
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

  // componentsRouter,
  

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
